export class WebhookV1AuditPayload {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "event",
            "baseName": "event",
            "type": "WebhookV1AuditEvent",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1AuditPayload.attributeTypeMap;
    }
    constructor() {
    }
}
